export const groupByCity = array =>
  Object.values(
    array.reduce((item, key) => {
      item[key.cityId] = [...(item[key.cityId] || []), key]
      return item
    }, {})
  )
